<section class="hero" [ngClass]=" {'is-dark': ctrl.busquedaActivada, 'is-primary': !ctrl.busquedaActivada } ">
    <div class="hero-body">
        <nav class="level ">
            <!-- Left side -->
            <div class="level-left ">
                <div class="level-item">
                    <p class="title" id="titulo_lista">
                        <span class="icon is-medium">
                            <i class="{{icono}}"></i>
                        </span>
                        <span class="icon is-medium">
                            <i class="icon-list "></i>
                        </span> {{modulo_actual}}
                    </p>
                </div>
            </div>

            <!-- Right side -->
            <div class="level-right ">
                <div class="level-item">
                    <div class="field is-grouped"  >
                        <div class="control has-icons-left is-expanded">
                            <input type="text" class="input is-flat is-medium" placeholder="Buscar" #searchBox id="search-box" (keyup)="ctrl.buscar(searchBox.value)">
                            <span class="icon is-medium is-left">
                                <i class="icon-search3"></i>
                            </span>
                        </div>
                    </div>
                </div>

                <a class="navbar-item tooltip"  *ngIf="filtro" (click)="abrirFiltros('filtros')" id="cargar_fitros">
                    <span class="icon fa-2x  has-text-link">
                        <i class="fa fa-binoculars"></i>
                    </span>
                    <span class="tooltiptext">Filtros</span>
                </a>

                <a class="navbar-item tooltip" (click)="ctrl.listar(1)" id='cargar_datos_actualizar' *ngIf="!ctrl.busquedaActivada">
                    <span class="icon fa-2x">
                        <i class="icon-worldwide"></i>
                    </span>
                    <span class="tooltiptext">Actualizar</span>
                </a>

                <a class="navbar-item tooltip" (click)="ctrl.listarBusqueda(searchBox.value,1)" id='cargar_datos_actualizar' *ngIf="ctrl.busquedaActivada">
                    <span class="icon fa-2x">
                        <i class="icon-worldwide"></i>
                    </span>
                    <span class="tooltiptext">Actualizar</span>
                </a>

                <a class="navbar-item tooltip" routerLink="{{url_nuevo}}" *ngIf="permisos.indexOf(controlador + '.store') > -1 || permisos.indexOf( 'Sis' + controlador + '.store') > -1">
                    <span class="icon fa-2x">
                        <i class="icon-file"></i>
                    </span>
                    <span class="tooltiptext">Nuevo</span>
                </a>

                <a class="navbar-item tooltip" (click)="ctrl.excel(modulo_actual);">
                    <span class="icon fa-2x">
                        <i class="fa fa-file-excel-o"></i>
                    </span>
                    <span class="tooltiptext">Exportar Excel</span>
                </a>

                <a class="navbar-item tooltip" (click)="ctrl.imprimir(null, '', modulo_actual);">
                    <span class="icon fa-2x">
                        <i class="icon-printer2"></i>
                    </span>
                    <span class="tooltiptext">Imprimir</span>
                </a>

                <a class="navbar-item  tooltip" (click)="ctrl.cambiar_vista();">
                    <span class="icon fa-2x">
                        <i class="icon-calendar22" *ngIf="!ctrl.tipo_grid"></i>
                        <i class="icon-list " *ngIf="ctrl.tipo_grid"></i>
                    </span>
                    <span class="tooltiptext" *ngIf="!ctrl.tipo_grid">Cambiar a tabla</span>
                    <span class="tooltiptext" *ngIf="ctrl.tipo_grid">Cambiar a lista</span>
                </a>

                <a class="navbar-item  is-dark tooltip" *ngIf="ctrl.busquedaActivada" (click)="ctrl.cerrar_busqueda(searchBox)">
                    <span class="icon fa-2x">
                        <i class="fa fa-close"></i>
                    </span>
                    <span class="tooltiptext">Cerrar Busqueda</span>
                </a>
            </div>
        </nav>
    </div>
</section>

<div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo">
    <div class="bloquear-azul">

    </div>
    <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
        <span class="icon">
            <i class="icon-worldwide fa-spin"></i>
        </span> &nbsp;
        <span>Cargando...</span>
    </span>
</div>
